import { assign, DoneInvokeEvent } from 'xstate';

export const assignResult = assign((context: any, ev: DoneInvokeEvent<any>) => {
  return {
    ...context,
    ...ev.data,
  };
});

export const every = (...guards: string[]) => ({
  type: 'every',
  guards,
});
